// removed by extract-text-webpack-plugin
module.exports = {"link":"src-components-modules-SmartLink-style----general-module---link---3b1un"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SmartLink/style/general.module.css
// module id = 1491
// module chunks = 168707334958949